import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
export function CTASection() {
  return <section className="py-20 bg-white" data-id="element-71">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="relative rounded-3xl overflow-hidden bg-gray-900 text-white px-8 py-16 text-center shadow-2xl" data-id="element-73">
          {/* Background Accents */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden" data-id="element-74">
            <div className="absolute top-0 left-0 w-64 h-64 bg-wh-pink opacity-20 rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2" data-id="element-75" />
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-wh-teal opacity-20 rounded-full blur-3xl transform translate-x-1/2 translate-y-1/2" data-id="element-76" />
          </div>

          <div className="relative z-10" data-id="element-77">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-78">
              Ready to bring your brand to life?
            </h2>
            <p className="text-gray-300 text-lg mb-10 max-w-2xl mx-auto" data-id="element-79">
              Whether you need 10 shirts or 10,000, we deliver quality that
              speaks for itself. Get a custom quote today.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-80">
              <Link to="/Contact" data-id="element-81">
                <Button variant="primary" size="lg" className="min-w-[160px]" data-id="element-82">
                  Get a Quote
                </Button>
              </Link>
              <Link to="/Contact" data-id="element-83">
                <Button variant="secondary" size="lg" className="min-w-[160px]" data-id="element-84">
                  Contact Us
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}